export default __webpack_public_path__ + "static/media/equipo5.1caf0d61.jpg";